import React, { useState, useEffect, useCallback } from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import { FloatingLabelSearchSelect } from '../elements/floatingLabelInput/FloatingLabelInput';
import { fetchProducts } from '../../api/webshop-products-orders-api';

const CreateSubscriptionPackageModal = ({ visible, onClose, onCreate, creating }) => {
  const [productId, setProductId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const loadSearchResults = useCallback(async (search) => {
    setSearchLoading(true);
    // Only products already created as "Pretplatnički paket (3/6/12)" that don't have a
    // package config yet — filtered server-side so the 20-result page isn't thinned out.
    const { data } = await fetchProducts({
      page: 1,
      limit: 20,
      search: search || null,
      isSubscriptionOnlyProduct: true,
      hasSubscriptionPackage: false,
    });
    if (data) {
      setSearchResults(data.products);
    }
    setSearchLoading(false);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const timer = setTimeout(() => loadSearchResults(searchTerm), 300);
    return () => clearTimeout(timer);
  }, [visible, searchTerm, loadSearchResults]);

  useEffect(() => {
    if (!visible) {
      setProductId(null);
      setSearchTerm('');
      setSearchResults([]);
    }
  }, [visible]);

  const productOptions = searchResults.map((p) => ({ value: p._id, label: p.name }));

  return (
    <Modal
      className="create_user_modal"
      title="Kreiraj paket za pretplatu"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" className="btn-tertiary" onClick={onClose} disabled={creating}>
          Otkaži
        </Button>,
        <Button
          key="create"
          type="primary"
          className="btn-primary"
          onClick={() => onCreate(productId)}
          disabled={!productId}
          loading={creating}
        >
          Kreiraj paket
        </Button>,
      ]}
    >
      <p style={{ marginBottom: 20 }}>
        Izaberite postojeći proizvod koji će biti označen kao pretplatnički paket (3/6/12), a zatim
        mu podesite proizvode u paketu i cene po periodu.
      </p>
      <FloatingLabelSearchSelect
        label="Pretraži proizvod"
        value={productId}
        onChange={setProductId}
        onSearch={setSearchTerm}
        loading={searchLoading}
        options={productOptions}
        notFoundContent='Nema proizvoda označenih kao "Pretplatnički paket (3/6/12)" bez podešenog paketa'
      />
    </Modal>
  );
};

CreateSubscriptionPackageModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  creating: PropTypes.bool,
};

export default CreateSubscriptionPackageModal;
